import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import IconSun from "app/components/Icon/components/IconSun/IconSun";
import LanguageSelect from "app/components/LanguageSelector/LanguageSelect";
import OddsSelector from "app/components/OddsSelector/OddsSelector";
import { GetOddsTranslationsHelper } from "app/helpers/getOddsTranslationsHelper";
import { getMainLogoPath } from "app/helpers/navigationUrlHelper";
import { getRoutePathForView } from "app/helpers/routerPathHelper";
import { UpdateOddsHelper } from "app/helpers/updateOddsHelper";
import { CompetitionType } from "app/types/competitionType";
import {
  DEFAULTSELECTEDLANGUAGE,
  OddsType,
  ResponsiveScreenSizesInt,
  ScreenType,
} from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import ENV from "config";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  IconLogo,
  IconLogoEvo,
  IconLogoGalaxyBet,
  IconMoon,
} from "../../components/Icon/Icon";
import { LanguageSelectionHelper } from "../../helpers/languageSelectionHelper";
import { SessionHelper } from "../../helpers/sessionHelper";
import type { EventType } from "../../types/eventType";
import AsianNavbar from "./components/AsianNavbar/AsianNavbar";
import ChangePlatformDropdown from "./components/ChangePlatformDropdown/ChangePlatformDropdown";
import LoginContact from "./components/LoginContact/LoginContact";
import NotificationHeader from "./components/NotificationHeader/NotificationHeader";
import PositionMatrix from "./components/PositionMatrix/PositionMatrix";
import { MenuItems } from "./helpers/MenuItems/MenuItems";
import { NavbarHelper } from "./helpers/NavbarHelper/NavbarHelper";
import "./NavBar.scss";
const MarketDataGraphsModal: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/MarketDataGraphsModal/MarketDataGraphsModal")
);
const UnsummarizedMarketsModal: React.LazyExoticComponent<any> = lazy(
  () =>
    import("../../components/UnsummarizedMarketsModal/UnsummarizedMarketsModal")
);
const SessionModal: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/SessionModal/SessionModal")
);
const BetPlacementModal: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/BetPlacementModal/BetPlacementModal")
);
/** The ID of the nav bar element */
export const NAV_BAR_ID = "navigation-bar";

function NavBar(props: {
  positionMatrixModalEvent: any;
  isPositionMatrixModalOpen: boolean;
  closePositionMatrixModal: (...args: Array<any>) => any;
  resetModelToDefault: (...args: Array<any>) => any;
  resetNavigation: (...args: Array<any>) => any;
  returnToPopularDefaultEvents: (...args: Array<any>) => any;
  session: Record<string, any>;
  setNotificationPlatform: (...args: Array<any>) => any;
  loadNotifications: (...args: Array<any>) => any;
  logout: (...args: Array<any>) => any;
  user: Record<string, any>;
  setSessionView: (...args: Array<any>) => any;
  updateSessionView: (...args: Array<any>) => any;
  showBetplacementModal: (...args: Array<any>) => any;
  updateShowBetplacementModal: (...args: Array<any>) => any;
  showMarketGraphModal: boolean;
  closeMarketGraphModal: (...args: Array<any>) => any;
  marketGraphModalEventData: EventType;
  userTimezone: Record<string, any>;
  intl: IntlShape;
  onLanguageChangeRequest: (...args: Array<any>) => any;
  isWebsocketReady: boolean;
  reconnecting: boolean;
  toggleDarkMode: Function;
  darkMode: boolean;
  oddsOptions: { label: string; value: string }[];
  competitionList: CompetitionType[];
  competitionListTotal: number;
  competitionListOffset: number;
  resetCompetitions: (...args: Array<any>) => any;
  setCompetitions: (...args: Array<any>) => any;
  isLoggedIn: boolean;
}) {
  const location = useLocation();
  const {
    userTimezone,
    closeMarketGraphModal,
    isPositionMatrixModalOpen,
    closePositionMatrixModal,
    positionMatrixModalEvent,
    isWebsocketReady,
    onLanguageChangeRequest,
    showMarketGraphModal,
    marketGraphModalEventData,
    session,
    updateShowBetplacementModal,
    reconnecting,
    toggleDarkMode,
    darkMode,
    oddsOptions,
    competitionList,
    competitionListOffset,
    resetCompetitions,
    setCompetitions,
    selectedCompetitionType,
    time,
    line,
    user,
    intl,
    isLoggedIn, // Added isLoggedIn from props
  } = props;

  const [showBetplacementModal, setShowBetplacementModal] = useState(false);
  const [logoItem, setLogoItem] = useState(MenuItems.logoItem);
  const [asianLogoItem, setAsianLogoItem] = useState(MenuItems.asianLogoItem);
  const [authenticatedMenuItems, setAuthenticatedMenuItems] = useState(
    MenuItems.authenticatedMenuItems
  );
  const [asianAuthenticatedMenuItems, setAsianAuthenticatedMenuItems] =
    useState(MenuItems.asianAuthenticatedMenuItems);
  const [selectedOddsType, setSelectedOddsType] = useState(OddsType.DECIMAL);

  useEffect(() => {
    const isMobile = window.innerWidth <= ResponsiveScreenSizesInt.mobile;

    // remove any search params from the url when in asian route
    if (SessionHelper.isAsianRoute() && location.search) {
      const cleanPath = location.pathname;
      window.history.replaceState(null, "", cleanPath);
    }
    // I think this was added to handle when desktop asian view was selected, then user goes to mobile
    // and then goes back to desktop view, to ensure that asian view is still selected
    // dont think it is needed anymore
    // but there might be an edge case where it is, so leaving it in for now

    if (!isMobile && session.uiViewMode) {
      if (
        session.uiViewMode === ScreenType.EUROPEAN &&
        SessionHelper.isAsianRoute()
      ) {
        // do nothing, let euro routing handle it
        // window.location.pathname = "/events/popular/";
      } else if (
        session.uiViewMode === ScreenType.ASIAN &&
        !SessionHelper.isAsianRoute()
      ) {
        window.location.pathname = "/asian/events/";
      }
    }
  }, [location.pathname, location.search, session]);

  useEffect(() => {
    // BET-14735 AC2 set to light mode for public view
    if (isPublicView()) {
      GetOddsTranslationsHelper.getOddsTranslations(intl);
    }
  }, []);

  useEffect(() => {
    updateShowBetplacementModal(showBetplacementModal);
  }, [showBetplacementModal]);

  useEffect(() => {
    const element = document.body;
    // toggle dark mode on Euro view only
    if (SessionHelper.isAuthenticated()) {
      if (darkMode && !element.classList.contains("dark")) {
        element.classList.add("dark");
      } else if (!darkMode && element.classList.contains("dark")) {
        element.classList.remove("dark");
      }
    }
  }, [darkMode]);

  useEffect(() => {
    if (user.preferences !== undefined) {
      if (user.preferences.oddsType !== selectedOddsType) {
        setSelectedOddsType(user.preferences.oddsType);
      }
    }
  }, [user]);

  const checkLanguageSelection = () => {
    const language = LanguageSelectionHelper.checkSelectedLanguage();
    if (language !== DEFAULTSELECTEDLANGUAGE) {
      return "/lang=" + language;
    }
    return "";
  };

  // used for update odds in public view
  const handleChangeOddsType = () => {
    // update store competition type with change
    // if previous collectionlist exist reset
    if (competitionList.length > 0) resetCompetitions();
    // get new compeitionsList
    setCompetitions();
  };

  // update odds drop down added for public view
  const updateOdds = (odds: string) => {
    UpdateOddsHelper.updateOdds(odds, handleChangeOddsType);
  };

  const link = getRoutePathForView();

  const mainLogoLink = getMainLogoPath(isPublicView(), location.pathname);

  return (
    <div
      className={`nav-bar__wrapper ${
        SessionHelper.isAuthenticated()
          ? "is-authenticated"
          : "not-authenticated"
      }`}
    >
      <div className="nav-bar__container--centered">
        {isLoggedIn && (
          <GeniusSiteTracking
            targetSelector=".nav-bar__container"
            eventType="change"
            pageName="loggedin"
            trackPageLoad={true}
          />
        )}
        <NotificationHeader />
        {SessionHelper.isAuthenticated() && !isWebsocketReady && (
          <div className={"websocket-failed-message"}>
            <FormattedMessage tagName="div" id="websocket-failed-message" />
            <span>
              {reconnecting ? <span>&nbsp;- Reconnecting...</span> : ""}
            </span>
          </div>
        )}
        <nav id={NAV_BAR_ID} className="nav-bar">
          {isPositionMatrixModalOpen && (
            <PositionMatrix
              isPositionMatrixModalOpen={isPositionMatrixModalOpen}
              closePositionMatrixModal={closePositionMatrixModal}
              positionMatrixModalEvent={positionMatrixModalEvent}
            />
          )}
          {showMarketGraphModal && (
            <Suspense fallback={<div className="fallback">loading...</div>}>
              <MarketDataGraphsModal
                closeModal={() => closeMarketGraphModal()}
                showModal={showMarketGraphModal}
                marketGraphModalEventData={marketGraphModalEventData}
                timezone={userTimezone}
              />
            </Suspense>
          )}
          <div className="nav-bar__container">
            <Suspense fallback={null}>
              <SessionModal />
            </Suspense>
            {SessionHelper.isAsianRouteAndSessionView() &&
              SessionHelper.isAuthenticated() && <UnsummarizedMarketsModal />}
            <Suspense fallback={null}>
              <BetPlacementModal />
            </Suspense>
            <NavLink
              className="nav-bar__nav-item nav-bar__nav-item--logo"
              exact
              to={mainLogoLink}
              activeClassName="nav-bar__nav-item--active"
            >
              {ENV.CSS_THEME === "DEFAULT" && <IconLogo />}
              {ENV.CSS_THEME === "EVO" && <IconLogoEvo />}
              {ENV.CSS_THEME === "GALAXYBET" &&
                SessionHelper.isAuthenticated() && <IconLogoGalaxyBet />}
            </NavLink>

            {SessionHelper.isAuthenticated() && ENV.CSS_THEME === "DEFAULT" && (
              <ChangePlatformDropdown data={props} />
            )}

            {/* commenting out this code, as enter site was visible on PP 
          uncomment to make it visible again */}
            {!SessionHelper.isAuthenticated() && (
              <a
                href={`https://${ENV.PUBLIC_DOMAIN}${checkLanguageSelection()}`}
                className="nav-bar__nav-item--public nav-bar__nav-item--contact"
              >
                {ENV.CSS_THEME === "DEFAULT" && (
                  <div className="nav-bar__nav-item--contact__text">
                    <FormattedMessage tagName="span" id="public-enter-site" />
                  </div>
                )}
              </a>
            )}
          </div>

          {/* Quick and dirty to hide login link */}

          <div
            className={`nav-bar__container nav-bar__nav-links ${
              isPublicView() && "public-navbar"
            } ${SessionHelper.isAsianSessionView() ? "asian " : "euro"}`}
          >
            {SessionHelper.isAuthenticated() &&
              isPublicView() &&
              oddsOptions && (
                <div className={"public-view-odds__dropdown"}>
                  <OddsSelector
                    oddsOptions={oddsOptions}
                    updateOdds={updateOdds}
                    selectedOdds={selectedOddsType}
                    disabled={false}
                  />
                </div>
              )}

            {isPublicView() &&
              SessionHelper.isAuthenticated() &&
              !SessionHelper.isAsianRouteAndSessionView() && (
                <>
                  <div className="language__input--row">
                    <LanguageSelect
                      onLanguageChangeRequest={onLanguageChangeRequest}
                      locale={LanguageSelectionHelper.checkSelectedLanguage()}
                      small={true}
                    />
                  </div>
                </>
              )}

            {/* To show language selector on landing and login pages */}
            {!SessionHelper.isAuthenticated() && (
              <LanguageSelect
                onLanguageChangeRequest={onLanguageChangeRequest}
                locale={LanguageSelectionHelper.checkSelectedLanguage()}
                small={true}
              />
            )}

            {isPublicView() ? (
              <LoginContact />
            ) : (
              NavbarHelper.checkPaths(location) && <LoginContact />
            )}

            {SessionHelper.isAuthenticated() &&
              props.user?.amsCanAccessCashier && (
                <span className={"nav-bar__deposit-placeholder"}>
                  <Link
                    to={link}
                    className="nav-bar__deposit-button"
                    id="manage-funding_button"
                  >
                    <FormattedMessage
                      tagName="span"
                      id="cashier-deposit-button"
                    />
                  </Link>
                </span>
              )}
            {SessionHelper.isAuthenticated() &&
              !SessionHelper.isAsianRouteAndSessionView() && (
                <span
                  onClick={() => toggleDarkMode()}
                  className={"dark-mode__button"}
                  title={"Dark Mode"}
                >
                  {darkMode ? <IconSun /> : <IconMoon />}
                </span>
              )}

            {SessionHelper.isAuthenticated() &&
              !SessionHelper.isAsianRouteAndSessionView() &&
              authenticatedMenuItems.map((item, index) => (
                <NavLink
                  className="nav-bar__nav-item nav-bar__nav-item--link"
                  exact
                  to={item.path}
                  key={index}
                  activeClassName="nav-bar__nav-item--active"
                  id={item.id}
                  aria-label={item.ariaLabel}
                >
                  <item.icon
                    isLightWhenActive
                    isActive={location.pathname.includes(item.path)}
                  />
                </NavLink>
              ))}
            {/* nav bar contents */}
            {SessionHelper.isAsianRouteAndSessionView() && (
              <AsianNavbar
                state={{
                  asianAuthenticatedMenuItems: asianAuthenticatedMenuItems,
                }}
                data={props}
                location={location}
                darkMode={darkMode}
                toggleDarkMode={() => toggleDarkMode()}
                onLanguageChangeRequest={onLanguageChangeRequest}
                userLanguage={user?.preferences?.language || session.language}
              />
            )}
            {/* nav bar contents   -- end */}
          </div>
        </nav>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  positionMatrixModalEvent:
    state.positionMatrixListModel.positionMatrixModalEvent,
  isPositionMatrixModalOpen:
    state.positionMatrixListModel.isPositionMatrixModalOpen,
  session: state.sessionModel.session,
  user: state.userModel.user,
  showMarketGraphModal: state.marketDataGraphModel.showMarketGraphModal,
  marketGraphModalEventData:
    state.marketDataGraphModel.marketGraphModalEventData,
  userTimezone: state.userModel.timezone,
  isWebsocketReady: state.subscribeModel.isWebsocketReady,
  reconnecting: state.subscribeModel.reconnecting,
  darkMode: state.sessionModel.darkMode,
  oddsOptions: state.competitionListModel.oddsOptions,
  competitionList: state.competitionListModel.competitionList,
  competitionListTotal: state.competitionListModel.competitionListTotal,
  competitionListOffset: state.competitionListModel.competitionListOffset,
  isLoggedIn: state.sessionModel.isLoggedIn,
});

const mapDispatchToProps = dispatch => ({
  closePositionMatrixModal: () => {
    dispatch.positionMatrixListModel.closePositionMatrixModal();
  },
  closeMarketGraphModal: () => {
    dispatch.marketDataGraphModel.closeMarketGraphModal();
  },
  resetModelToDefault: () => {
    dispatch.navigationModel.resetModelToDefault();
  },
  setNotificationPlatform: platform => {
    dispatch.notificationListModel.setPlatform(platform);
  },
  loadNotifications: platform => {
    dispatch.notificationListModel.loadNotificationList();
  },
  setSessionView: (view: string) => {
    dispatch.sessionModel.setSessionView(view);
  },
  updateSessionView: (view: string) => {
    dispatch.sessionModel.updateSessionView(view);
  },
  updateShowBetplacementModal: (show: boolean) => {
    dispatch.navigationModel.updateShowBetplacementModal(show);
  },
  onLanguageChangeRequest: (lang: string) => {
    dispatch.profileModel.onLanguageChange(lang);
  },
  toggleDarkMode: () => {
    dispatch.sessionModel.toggleDarkMode();
  },
  resetCompetitions: () => {
    dispatch.competitionListModel.resetCompetition();
  },
  setCompetitions: () => {
    dispatch.competitionListModel.setEuroCompetitionList();
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NavBar));
